module.exports = __webpack_public_path__ + "img/imagen10.044f8005.png";